<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-tooltip bottom>
                            <template #activator="{ on, attrs }">
                                <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                                    @click="goBack()" v-on="on" v-bind="attrs">
                                    <v-icon left>mdi-arrow-left</v-icon>
                                    Voltar
                                </v-btn>
                            </template>
                            <span>Voltar para a listagem do QGC</span>
                        </v-tooltip>

                        <v-tooltip bottom v-if="isEditMode || isNewMode">
                            <template #activator="{ on, attrs }">
                                <v-btn id="btnSave" type="button" elevation="0" color="primary"
                                    :loading="dataForm.saveLoading"
                                    @click="save" class="ml-2" v-on="on" v-bind="attrs">
                                    <v-icon left>mdi-content-save</v-icon>
                                    Salvar
                                </v-btn>
                            </template>
                            <span>Salvar alterações do credor</span>
                        </v-tooltip>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">
                                    Detalhes
                                    <v-spacer />
                                    <v-chip small :color="isEditMode ? 'warning' : 'grey'" label text-color="white">
                                        <v-icon left small>{{ isEditMode ? 'mdi-pencil' : 'mdi-eye' }}</v-icon>
                                    {{ isNewMode ? 'Novo' : isEditMode ? 'Edição' : 'Visualização' }}
                                    </v-chip>
                                </v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Nome" v-model="dataset.data.name" required
                                                :readonly="!isEditMode && !isNewMode" outlined hide-details="auto"
                                                :rules="[$rules.required]">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense id="registration" label="CPF/CNPJ"
                                                v-model="dataset.data.registration" required
                                                outlined hide-details="auto" :readonly="!isNewMode"
                                                :rules="[$rules.required]">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Email" v-model="dataset.data.email"
                                                outlined hide-details="auto" :readonly="!isEditMode && !isNewMode">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-select dense :items="dataset.creditorTypes" label="Classe"
                                                v-model="dataset.data.type" item-value="id" item-text="name" outlined
                                                hide-details="auto" :readonly="!isEditMode && !isNewMode"
                                                :rules="[$rules.required]">
                                            </v-select>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" sm="3">
                                            <v-select dense :items="dataset.currencyTypes" label="Moeda"
                                                v-model="dataset.data.currency" item-value="id" item-text="name" outlined
                                                hide-details="auto" :readonly="!isEditMode && !isNewMode"
                                                :rules="[$rules.required]">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" sm="3">
                                            <v-currency-field label="Valor" dense v-model="dataset.data.amount"
                                                :allowNegative=false hide-details="auto" outlined
                                                :readonly="!isEditMode && !isNewMode"
                                                :rules="[$rules.required]">
                                            </v-currency-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-select v-model="dataset.data.version" label="Versão do QGC"
                                                :items="dataset.versionOptions" item-text="label" item-value="id"
                                                outlined dense hide-details="auto" :readonly="!isNewMode" />
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>

                    <v-row class="mt-4" v-if="!isNewMode">
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">
                                    <v-icon left>mdi-bank-transfer</v-icon>
                                    Movimentações financeiras
                                    <v-spacer />
                                    <v-chip small :color="dataset.financialMovements.length > 0 ? 'success' : 'grey'" label text-color="white">
                                        {{ dataset.financialMovements.length }} {{ dataset.financialMovements.length === 1 ? 'movimentação' : 'movimentações' }}
                                    </v-chip>
                                </v-card-title>
                                <v-card-text>
                                    <v-alert v-if="dataset.financialMovements.length === 0" type="info" text dense class="mb-0">
                                        Nenhuma movimentação financeira encontrada para este CPF/CNPJ.
                                    </v-alert>

                                    <v-simple-table v-else dense class="financial-movements-table">
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th>Papel</th>
                                                    <th>Valor</th>
                                                    <th>Responsável/Pagador</th>
                                                    <th>Processo</th>
                                                    <th>Status</th>
                                                    <th>Documento</th>
                                                    <th class="text-right">Ações</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="movement in dataset.financialMovements" :key="movement.id">
                                                    <td>
                                                        <v-chip v-for="role in movement.movement_roles" :key="role" x-small label
                                                            :color="role === 'payer' ? 'deep-purple' : 'primary'" text-color="white" class="mr-1">
                                                            {{ getMovementRoleLabel(role) }}
                                                        </v-chip>
                                                    </td>
                                                    <td class="font-weight-medium">{{ formatCurrency(movement.paid_amount) }}</td>
                                                    <td>
                                                        <div>{{ movement.payer_name || movement.payment_responsible || '—' }}</div>
                                                        <small class="grey--text">{{ formatRegistration(movement.payer_registration) || 'Sem CPF/CNPJ' }}</small>
                                                    </td>
                                                    <td>{{ movement.process_number || '—' }}</td>
                                                    <td>
                                                        <v-chip x-small :color="getPaymentProofStatusColor(movement.status)" text-color="white">
                                                            {{ getPaymentProofStatusLabel(movement.status) }}
                                                        </v-chip>
                                                        <v-tooltip bottom v-if="movement.has_inconsistency">
                                                            <template #activator="{ on, attrs }">
                                                                <v-icon small color="warning" class="ml-1" v-on="on" v-bind="attrs">
                                                                    mdi-alert-circle-outline
                                                                </v-icon>
                                                            </template>
                                                            <span>{{ movement.inconsistency_reason || 'Comprovante com inconsistência.' }}</span>
                                                        </v-tooltip>
                                                    </td>
                                                    <td>
                                                        <div>{{ movement.document_name || 'Comprovante anexado' }}</div>
                                                        <small class="grey--text">{{ getPaymentProofDocumentTypeLabel(movement.document_type) }}</small>
                                                    </td>
                                                    <td class="text-right">
                                                        <v-btn small outlined color="primary" @click="openPaymentProof(movement)">
                                                            <v-icon left small>mdi-paperclip</v-icon>
                                                            Comprovante
                                                        </v-btn>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>

                    <!-- Bloco de Histórico de Alterações -->
                    <v-row class="mt-4">
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">
                                    <v-icon left>mdi-history</v-icon>
                                    Histórico de alterações
                                    <v-spacer />
                                    <v-chip small :color="dataset.auditHistory.length > 0 ? 'info' : 'grey'" label text-color="white">
                                        {{ dataset.auditHistory.length }} {{ dataset.auditHistory.length === 1 ? 'alteração' : 'alterações' }}
                                    </v-chip>
                                </v-card-title>
                                <v-card-text>
                                    <div v-if="dataForm.historyLoading" class="text-center py-4">
                                        <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
                                        <div class="mt-2 grey--text">Carregando histórico...</div>
                                    </div>

                                    <v-alert v-else-if="dataset.auditHistory.length === 0" type="info" text dense class="mb-0">
                                        Nenhuma alteração registrada para este credor.
                                    </v-alert>

                                    <v-timeline v-else dense align-top>
                                        <v-timeline-item
                                            v-for="(audit, index) in dataset.auditHistory"
                                            :key="index"
                                            :color="audit.action === 'edit' ? 'warning' : 'error'"
                                            :icon="audit.action === 'edit' ? 'mdi-pencil' : 'mdi-delete'"
                                            small
                                        >
                                            <v-card outlined class="pa-3">
                                                <div class="d-flex align-center mb-2">
                                                    <v-chip x-small label
                                                        :color="audit.action === 'edit' ? 'warning' : 'error'"
                                                        text-color="white" class="mr-2">
                                                        {{ audit.action === 'edit' ? 'EDIÇÃO' : 'REMOÇÃO' }}
                                                    </v-chip>
                                                    <span class="caption grey--text">
                                                        Revisão #{{ audit.revision }} — {{ formatDate(audit.created_at) }}
                                                    </span>
                                                    <v-spacer />
                                                    <span class="caption grey--text" v-if="audit.admin_id">
                                                        <v-icon x-small class="mr-1">mdi-account</v-icon>
                                                        Admin #{{ audit.admin_id }}
                                                    </span>
                                                </div>

                                                <!-- Campos alterados (edit) -->
                                                <template v-if="audit.action === 'edit' && audit.new_data">
                                                    <v-simple-table dense class="audit-diff-table">
                                                        <thead>
                                                            <tr>
                                                                <th style="width: 120px; min-width: 120px;">Campo</th>
                                                                <th style="width: 200px; min-width: 200px;">Valor Anterior</th>
                                                                <th style="width: 200px; min-width: 200px;">Novo Valor</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="field in getChangedFields(audit)" :key="field.key">
                                                                <td class="font-weight-medium">{{ field.label }}</td>
                                                                <td>
                                                                    <span v-if="field.changed" class="red--text text--lighten-1">
                                                                        <del>{{ field.oldValue }}</del>
                                                                    </span>
                                                                    <span v-else class="grey--text">{{ field.oldValue }}</span>
                                                                </td>
                                                                <td>
                                                                    <v-chip v-if="field.changed" small color="green lighten-4" text-color="green darken-3" label class="font-weight-bold">
                                                                        <v-icon x-small left>mdi-arrow-right-bold</v-icon>
                                                                        {{ field.newValue }}
                                                                    </v-chip>
                                                                    <span v-else class="grey--text">{{ field.newValue }}</span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </v-simple-table>
                                                </template>

                                                <!-- Motivo (delete) -->
                                                <template v-if="audit.action === 'delete' && audit.reason">
                                                    <div class="mt-1">
                                                        <span class="caption font-weight-medium">Motivo:</span>
                                                        <span class="caption ml-1">{{ audit.reason }}</span>
                                                    </div>
                                                </template>
                                            </v-card>
                                        </v-timeline-item>
                                    </v-timeline>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>

<script>
import creditorTypes from "@/common/data/creditor-types.data"
import eventStatus from "@/common/data/event-status.data"
import currencyTypes from "@/common/data/currency-types.data"
import qgcVersions from '@/common/data/qgc-versions.data.js';
import paymentProofDocumentTypes from "@/common/data/payment-proof-document-types.data";
import paymentProofStatuses from "@/common/data/payment-proof-status.data";

import { cpf, cnpj } from 'cpf-cnpj-validator'

import axios from "axios"

export default {
    name: "QgcUnifiedDetails",

    data: () => ({
        user: null,
        page: {
            title: "",
        },
        context: {
            id: null,
            mode: 'view',
        },
        dataset: {
            breadcrumbItems: [],
            eventStatus: eventStatus,
            currencyTypes: currencyTypes,
            data: {
                name: "",
                email: "",
                registration: "",
                type: null,
                currency: 1,
                amount: 0,
                version: 3,
            },
            creditorTypes: creditorTypes,
            versionOptions: qgcVersions,
            auditHistory: [],
            financialMovements: [],
            paymentProofDocumentTypes: paymentProofDocumentTypes,
            paymentProofStatuses: paymentProofStatuses,
        },
        dataForm: {
            validForm: true,
            saveLoading: false,
            historyLoading: false,
        },
    }),

    computed: {
        isEditMode() {
            return this.context.mode === 'edit';
        },
        isNewMode() {
            return this.context.mode === 'new';
        },
    },

    created() {
        this.loadContext();
    },

    methods: {

        fieldLabels: {
            name: 'Nome',
            email: 'Email',
            registration: 'CPF/CNPJ',
            type: 'Classe',
            currency: 'Moeda',
            amount: 'Valor',
        },

        loadContext() {
            if (this.$route.path === '/qgc/novo') {
                this.context.id = null;
                this.context.mode = 'new';
                this.loadData();
                return;
            }

            var saved = sessionStorage.getItem('qgcDetailContext');

            if (!saved) {
                this.$dialog.notify.error('Nenhum registro selecionado.', {
                    position: 'top-right',
                    timeout: 3000
                });
                this.$router.replace('/qgc');
                return;
            }

            try {
                var ctx = JSON.parse(saved);
                this.context.id = ctx.id;
                this.context.mode = ctx.mode || 'view';
            } catch (e) {
                this.$router.replace('/qgc');
                return;
            }

            this.loadData();
        },

        goBack() {
            sessionStorage.removeItem('qgcDetailContext');
            this.$router.replace('/qgc');
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();
            await this.load();
            await this.loadAuditHistory();
        },

        setPage() {
            this.page.title = this.isNewMode ? 'Novo credor' : this.isEditMode ? 'Editar credor' : 'Detalhes do credor';
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
                {
                    text: "QGC",
                    disabled: false,
                    to: "/qgc",
                    exact: true,
                },
                {
                    text: this.page.title,
                    disabled: true,
                    exact: true,
                },
            ];
        },

        formatRegistration(registration) {
            if (registration) {
                return registration.length < 14
                    ? cpf.format(registration)
                    : cnpj.format(registration);
            }
            return '';
        },

        formatDate(dateStr) {
            if (!dateStr) return '';
            var d = new Date(dateStr);
            return d.toLocaleDateString('pt-BR') + ' ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
        },

        formatCurrency(value) {
            return Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },

        getMovementRoleLabel(role) {
            if (role === 'payer') return 'Pagador';
            if (role === 'creditor') return 'Credor';
            return role || '—';
        },

        getPaymentProofStatusLabel(status) {
            var found = this.dataset.paymentProofStatuses.find(function(item) { return item.id === status; });
            return found ? found.name : status || '—';
        },

        getPaymentProofStatusColor(status) {
            return {
                submitted: 'primary',
                in_review: 'info',
                inconsistent: 'warning',
                validated: 'success',
                rejected: 'error',
            }[status] || 'grey';
        },

        getPaymentProofDocumentTypeLabel(type) {
            var found = this.dataset.paymentProofDocumentTypes.find(function(item) { return item.id === type; });
            return found ? found.name : type || '—';
        },

        openPaymentProof(movement) {
            this.$router.push(movement.payment_proof_url || ('/comprovantes-pagamento/' + movement.id));
        },

        formatFieldValue(key, value) {
            if (value === null || value === undefined) return '—';

            if (key === 'type') {
                var found = this.dataset.creditorTypes.find(function(t) { return t.id === value; });
                return found ? found.name : value;
            }
            if (key === 'currency') {
                var curr = this.dataset.currencyTypes.find(function(c) { return c.id === value; });
                return curr ? curr.name : value;
            }
            if (key === 'amount') {
                return Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
            }
            if (key === 'registration') {
                return this.formatRegistration(String(value));
            }

            return value;
        },

        getChangedFields(audit) {
            var self = this;
            var fields = [];
            var fieldLabels = {
                name: 'Nome',
                email: 'Email',
                registration: 'CPF/CNPJ',
                type: 'Classe',
                currency: 'Moeda',
                amount: 'Valor',
            };

            if (!audit.new_data || !audit.old_data) return fields;

            for (var key in audit.new_data) {
                if (key === 'revision' || key === 'version') continue;
                if (!fieldLabels[key]) continue;

                var oldRaw = audit.old_data[key];
                var newRaw = audit.new_data[key];
                var changed = String(oldRaw) !== String(newRaw);

                fields.push({
                    key: key,
                    label: fieldLabels[key],
                    oldValue: self.formatFieldValue(key, oldRaw),
                    newValue: self.formatFieldValue(key, newRaw),
                    changed: changed,
                });
            }

            return fields;
        },

        async load() {
            this.user = this.$root.user.data || this.$root.user;

            if (this.isNewMode) return;

            try {
                const result = await axios.get('/api/admin/users-creditors-claim/' + this.context.id);

                const data = result.data.content.data;

                this.dataset.data = data;
                this.dataset.financialMovements = data.financial_movements || [];

                if (this.dataset.data.registration) {
                    this.dataset.data.registration = this.formatRegistration(this.dataset.data.registration);
                }

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            }
        },

        async loadAuditHistory() {
            if (this.isNewMode) {
                this.dataset.auditHistory = [];
                return;
            }

            this.dataForm.historyLoading = true;

            try {
                var result = await axios.get('/api/admin/users-creditors-claim/' + this.context.id + '/history');
                this.dataset.auditHistory = result.data.content.data || [];
            } catch (error) {
                this.dataset.auditHistory = [];
            } finally {
                this.dataForm.historyLoading = false;
            }
        },

        async save() {
            if (!this.$refs.form.validate()) return;

            this.dataForm.saveLoading = true;

            try {
                const payload = {
                    ...this.dataset.data,
                    registration: this.dataset.data.registration
                        ? this.dataset.data.registration.replace(/\D/g, '')
                        : null,
                };

                let result = null;

                if (this.isNewMode) {
                    result = await axios.post('/api/admin/users-creditors-claim', payload);
                } else {
                    result = await axios.patch('/api/admin/users-creditors-claim/' + this.context.id, payload);
                }

                this.$dialog.notify.success(this.isNewMode ? 'Credor criado com sucesso!' : 'Credor atualizado com sucesso!', {
                    position: 'top-right',
                    timeout: 2000
                });

                if (this.isNewMode) {
                    var created = result.data.content.data;
                    sessionStorage.setItem('qgcDetailContext', JSON.stringify({
                        id: created.id,
                        mode: 'view'
                    }));
                    this.$router.replace('/qgc/detalhes');
                    return;
                }

                // Recarrega dados e histórico após salvar
                await this.load();
                await this.loadAuditHistory();

                // Volta para modo visualização após salvar
                this.context.mode = 'view';
                this.setPage();

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            } finally {
                this.dataForm.saveLoading = false;
            }
        },

    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    font-size: 14px;
    font-style: normal;
}

.audit-diff-table {
    table {
        table-layout: fixed;
        width: 100%;
    }
    th {
        font-size: 12px !important;
        color: rgba(0, 0, 0, 0.6) !important;
    }
    td {
        font-size: 13px !important;
        word-break: break-word;
    }
}
</style>
